// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__aIeo5","terms":"footer_terms__KHDpb"};